export class ChangePasswordUser {
    Username : string = "";
    OldPassword : string = "";
    NewPassword : string = "";
}

export default ChangePasswordUser;